module.exports = __webpack_public_path__ + "img/model_61.9aa0f306.jpg";